import { render, staticRenderFns } from "./EditLeadPodDialog.vue?vue&type=template&id=a1b165fa&scoped=true"
import script from "./EditLeadPodDialog.vue?vue&type=script&lang=ts"
export * from "./EditLeadPodDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditLeadPodDialog.vue?vue&type=style&index=0&id=a1b165fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b165fa",
  null
  
)

export default component.exports